import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Consent for multi-month refills',
    field: 'pocketpills_waiver',
    type: 'select',
    educationalSlide: `
    <p>When you choose more than one month of your medication, it ships as a larger order.</p>
    <p>Wegovy and Ozempic stay stable at room temperature for up to 56 days. Zepbound and Mounjaro stay stable at room temperature for up to 30 days. We normally ship monthly to keep medications in the best condition. On the rare occasion a shipment is delayed in transit, larger orders can be affected.</p>
    <p>By giving your consent below, you're letting us know you're happy to receive multi-month supplies going forward, and that you understand a refund or replacement will not be possible if a delay affects your medication in transit.</p>
    <p>You can change this preference anytime — just reach out to our team before your next refill.</p>
    `,
    answer: {
      type: 'single_select',
      required: true,
      options: [
        {
          value: 'I consent to multi-month refills',
          class: 'option-consent',
          key: 'consent',
          answer: {
            type: 'text',
            label: 'Type your full name to sign',
            placeholder: 'Your full name',
            name: 'fullName'
          }
        },
        {
          value: 'I do not consent to multi-month refills',
          class: 'option-decline',
          key: 'non_consent'
        }
      ]
    }
  }
];

export default questionsModels;
